/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Remove curved stage border",
  "description": "Removes the curved border around the stage, allowing you to see the corners.",
  "tags": [
    "theme"
  ],
  "credits": [
    {
      "name": "Tacodiva",
      "link": "https://scratch.mit.edu/users/Tacodiva7729/"
    }
  ],
  "enabledByDefault": false,
  "dynamicDisable": true,
  "userstyles": [
    {
      "url": "remove-borders.css"
    }
  ]
};
export default manifest;
